// Content transcribed from GoQuiz (User Guide).docx, in document order.
export default {
  en: [
    { title: 'Categories', paragraphs: [
      'Choose your preferred category from 4 options: Music, Movies, Countries, and Sports, or let the system select one randomly.'
    ] },
    { title: 'Quiz Center', topics: [
      { title: 'AI Training', text: 'Choose from 3 difficulty levels and answer 10 questions. Each correct answer earns 10 points.' },
      { title: 'Ranked Mode', text: 'The system matches you with an opponent of a similar level. Both players answer 10 questions. Each correct answer earns 10 points.' },
      { title: 'Team Mode', text: 'Create and share a Room Number with your friends to play together. 10 questions are given, and each correct answer earns 10 points.' },
      { title: 'Endless Mode', text: 'Answer each question correctly within 10 seconds. The quiz ends when you fail to answer correctly. Each correct answer earns 10 points.' },
      { title: 'Guess the Word', text: 'Identify the word based on the given images. 10 questions are given, and each correct answer earns 10 points.' },
      { title: 'Music Quiz', text: 'Listen to a song and answer questions. 10 questions are given, and each correct answer earns 10 points.' },
      { title: 'Video Quiz', text: 'Watch a movie/video and answer questions. 10 questions are given, and each correct answer earns 10 points.' }
    ] },
    { title: 'Ranking', paragraphs: [
      'Weekly Ranking – Based on total points earned from Monday to Sunday, until 12:00 AM.',
      'Monthly Ranking – Based on total points earned from the 1st to the last day of the month, until 12:00 AM.'
    ] }
  ],
  bur: [
    { title: 'အမျိုးအစားများ', paragraphs: [
      'သီချင်း၊ ရုပ်ရှင်၊ နိုင်ငံ၊ အားကစား စသည့် (၄) မျိုးမှ နှစ်သက်ရာအမျိုးအစားကို ရွေးချယ်ထားနိုင်သည်။ (သို့) ကျပန်းရွေးချယ်ထားနိုင်သည်။'
    ] },
    { title: 'မေးခွန်းဖြေဆိုရန်', topics: [
      { title: 'AIလေ့ကျင့်မှု', text: 'AIနှင့် လေ့ကျင့်မှုတွင် အဆင့် (၃) မျိုးပေးထားပြီး မေးခွန်း (၁၀) မျိုး အပြိုင် ဖြေဆိုရမည်။ မေးခွန်း (၁) ခုမှန်လျှင် (၁၀)မှတ် ရရှိပါမည်။' },
      { title: 'အဆင့်သတ်မှတ်ပုံစံ', text: 'မိမိလယ်ဗယ်နှင့် တူညီသော ပြိုင်ဘက်ရှာဖွေပေးပြီး မေးခွန်း (၁၀) မျိုး အပြိုင် ဖြေဆိုရမည်။ မေးခွန်း (၁) ခုမှန်လျှင် (၁၀)မှတ် ရရှိပါမည်။' },
      { title: 'အဖွဲ့လိုက်ပုံစံ', text: 'မိမိမိတ်ဆွေများကို ကစားခန်းနံပါတ်ဖန်တီးပေးပို့ပြီး အတူကစားနိုင်သည်။ မေးခွန်း (၁၀) ခု ပေးထားပြီး (၁) ခုမှန်လျှင် (၁၀)မှတ် ရရှိပါမည်။' },
      { title: 'အဆုံးမဲ့ပုံစံ', text: 'မေးခွန်းတစ်ခုလျှင် ၁၀ စက္ကန့်အတွင်း အမှားအယွင်းမရှိ ဖြေဆိုနိုင်ရမည်။ မဖြေဆိုနိုင်ပါက ဉာဏ်စမ်းပွဲရပ်တန့်မည်။ မေးခွန်း (၁) ခုမှန်လျှင် (၁၀)မှတ် ရရှိပါမည်။' },
      { title: 'စကားလုံးခန့်မှန်းပါ', text: 'ရုပ်ပုံများကြည့်ပြီး စကားလုံးဖော်ထုတ်ရမည်။ မေးခွန်း (၁၀) ခု ပေးထားပြီး (၁) ခုမှန်လျှင် (၁၀)မှတ် ရရှိပါမည်။' },
      { title: 'သီချင်းမေးခွန်း', text: 'သီချင်းနားထောင်ပြီး သီချင်းနှင့်သက်ဆိုင်သော မေးခွန်းများဖြေဆိုရမည်။ မေးခွန်း (၁၀) ခု ပေးထားပြီး (၁) ခုမှန်လျှင် (၁၀)မှတ် ရရှိပါမည်။' },
      { title: 'ဗီဒီယိုမေးခွန်း', text: 'ရုပ်ရှင်ကြည့်ပြီး ရုပ်ရှင်နှင့်သက်ဆိုင်သော မေးခွန်းများဖြေဆိုရမည်။ မေးခွန်း (၁၀) ခု ပေးထားပြီး (၁) ခုမှန်လျှင် (၁၀)မှတ် ရရှိပါမည်။' }
    ] },
    { title: 'အဆင့်သတ်မှတ်ပုံ', paragraphs: [
      'အပတ်စဉ်အဆင့် – တနင်္လာနေ့မှ တနင်္ဂနွေနေ့ ည ၁၂:၀၀ နာရီအထိ ရရှိသည့် ရမှတ်စုစုပေါင်းဖြင့် သတ်မှတ်သည်။',
      'လစဉ်အဆင့် – လအစမှ လကုန် ည ၁၂:၀၀ နာရီအထိ ရရှိသည့် ရမှတ်စုစုပေါင်းဖြင့် သတ်မှတ်သည်။'
    ] }
  ]
}



// WEBPACK FOOTER //
// ./src/assets/content/userGuide.js